import { render, staticRenderFns } from "./FrequentlyUsedCoupons.vue?vue&type=template&id=ccccadf8&scoped=true&"
import script from "./FrequentlyUsedCoupons.vue?vue&type=script&lang=js&"
export * from "./FrequentlyUsedCoupons.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyUsedCoupons.vue?vue&type=style&index=0&id=ccccadf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccccadf8",
  null
  
)

export default component.exports